import Vue from 'vue'

import BaseCard from '@/components/base/BaseCard.vue';
import Placeholder from '@/components/base/Placeholder.vue';
import TkArtwork from '@/components/core/TkArtwork.vue';
import TkBtn from '@/components/core/TkBtn.vue';
import TkMedia from '@/components/core/TkMedia.vue';
import BaseContainer from '@/components/base/BaseContainer.vue';


Vue.component(BaseCard.name, BaseCard);
Vue.component(TkArtwork.name, TkArtwork);
Vue.component(Placeholder.name, Placeholder);
Vue.component(TkBtn.name, TkBtn);
Vue.component(TkMedia.name, TkMedia);
Vue.component(BaseContainer.name, BaseContainer);

